import {EventEmitter} from '@billjs/event-emitter';


export default class DialogManager extends EventEmitter{
  constructor(){
    super();
    this.scripts = null;
    this.isReady = false;
  }


  async load() {
    const path = `${window.location.origin +(window.location.pathname === "/" ? "" : window.location.pathname)}/assets/dialogs.json`;

    const response = await fetch(path);
    this.scripts = await response.json();
    this.isReady = true;
  }

  getDialog(levelName,elderIndex,convoId,options=null){

    if(!this.scripts.hasOwnProperty(levelName)){
      console.log("Error. No dialog for that level.");
      return null;
    }

    let elderId = "elder_" + elderIndex;

    if(convoId == "riddles"){
      let part = options['part'];
      if (part === 'riddle') {
        let riddleDialog = this.scripts[levelName][elderId][convoId][0][part];
        // Mark riddle dialogs explicitly
        return riddleDialog.map(item => ({...item, isRiddle: true}));
      } else {
        return this.scripts[levelName][elderId][convoId][0][part];
      }
    }else{
      let dialog = this.scripts[levelName][elderId][convoId];
      return dialog;
    }
  }

  getSolutions(levelName){
    if(!this.scripts.hasOwnProperty(levelName)){
      console.log("Error. No dialog for that level.");
      return null;
    }

    let dialogs = this.scripts[levelName];
    let solutions = [];

    for (const [key, value] of Object.entries(dialogs)) {
      let solution = dialogs[key]["riddles"][0]["word"];
      solutions.push({"solution":solution});
    }

    return solutions;
  }

  getGuardianSolution(levelName){
    if(!this.scripts.hasOwnProperty(levelName)){
      console.log("Error. No dialog for that level.");
      return null;
    }
    let dialogs = this.scripts[levelName];
    let solution = dialogs["elder_1"]["riddles"][0]["word"];
    return solution;
  }

  getReadTimeSeconds(text){
    let minTime = 3;
    let words = text.split(" ");
    return Math.max(minTime,(words.length / 190) * 60);
  }
};
